// extracted by mini-css-extract-plugin
export var numpadContainer = "_mx-1";
export var phoneButton = "_mx-0";